__turbopack_context__.v({
  "actions": "Content-module-scss-module__tM5JbG__actions",
  "body": "Content-module-scss-module__tM5JbG__body",
  "button": "Content-module-scss-module__tM5JbG__button",
  "byline": "Content-module-scss-module__tM5JbG__byline",
  "container": "Content-module-scss-module__tM5JbG__container",
  "content": "Content-module-scss-module__tM5JbG__content",
  "hasImage": "Content-module-scss-module__tM5JbG__hasImage",
  "hero": "Content-module-scss-module__tM5JbG__hero",
  "hiddenOnMobile": "Content-module-scss-module__tM5JbG__hiddenOnMobile",
  "icon": "Content-module-scss-module__tM5JbG__icon",
  "iconLabel": "Content-module-scss-module__tM5JbG__iconLabel",
  "image": "Content-module-scss-module__tM5JbG__image",
  "inner": "Content-module-scss-module__tM5JbG__inner",
  "layout": "Content-module-scss-module__tM5JbG__layout",
  "link": "Content-module-scss-module__tM5JbG__link",
  "mediaLeft": "Content-module-scss-module__tM5JbG__mediaLeft",
  "mediaRight": "Content-module-scss-module__tM5JbG__mediaRight",
  "multimedia": "Content-module-scss-module__tM5JbG__multimedia",
  "playIcon": "Content-module-scss-module__tM5JbG__playIcon",
  "playIconWrapper": "Content-module-scss-module__tM5JbG__playIconWrapper",
  "quote": "Content-module-scss-module__tM5JbG__quote",
  "sectionTitle": "Content-module-scss-module__tM5JbG__sectionTitle",
  "shadow": "Content-module-scss-module__tM5JbG__shadow",
  "title": "Content-module-scss-module__tM5JbG__title",
  "video": "Content-module-scss-module__tM5JbG__video",
  "visibleOnMobile": "Content-module-scss-module__tM5JbG__visibleOnMobile",
});
